module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "flex-container column"
  }, [_c('div', {
    staticClass: "item input border1"
  }, [_c('div', {
    staticClass: "border1"
  }, [_c('Row', [_c('div', {
    staticStyle: {
      "font-size": "18px",
      "color": "white",
      "background-color": "#2d8cf0"
    }
  }, [_vm._v("设置转化率 α")])]), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('i-col', {
    attrs: {
      "span": "8"
    }
  }, [_vm._v("起始值")]), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "8"
    }
  }, [_vm._v("最大值")]), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "8"
    }
  }, [_vm._v("间隔值")])], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "6px"
    },
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "span": "8"
    }
  }, [_c('Input-number', {
    attrs: {
      "size": "small",
      "step": 0.1
    },
    model: {
      value: (_vm.convRate.min),
      callback: function($$v) {
        _vm.$set(_vm.convRate, "min", $$v)
      },
      expression: "convRate.min"
    }
  })], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "8"
    }
  }, [_c('Input-number', {
    attrs: {
      "size": "small",
      "step": 0.1
    },
    model: {
      value: (_vm.convRate.max),
      callback: function($$v) {
        _vm.$set(_vm.convRate, "max", $$v)
      },
      expression: "convRate.max"
    }
  })], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "8"
    }
  }, [_c('Input-number', {
    attrs: {
      "size": "small",
      "step": 0.01
    },
    model: {
      value: (_vm.convRate.step),
      callback: function($$v) {
        _vm.$set(_vm.convRate, "step", $$v)
      },
      expression: "convRate.step"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "border1"
  }, [_c('Row', {
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('i-col', {
    attrs: {
      "span": "10"
    }
  }, [_c('label', {
    attrs: {
      "for": "fa"
    }
  }, [_vm._v("机理方程")])]), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "14"
    }
  }, [_c('Select', {
    attrs: {
      "id": "fa",
      "size": "small"
    },
    on: {
      "on-change": _vm.onSelectChange
    },
    model: {
      value: (_vm.reactionFunc),
      callback: function($$v) {
        _vm.reactionFunc = $$v
      },
      expression: "reactionFunc"
    }
  }, _vm._l((_vm.jilifuncs), function(item, index) {
    return _c('Option', {
      key: item.name,
      attrs: {
        "value": index
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 1)], 1)], 1), _vm._v(" "), _c('hr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMNInput),
      expression: "showMNInput"
    }],
    staticStyle: {
      "margin-top": "6px",
      "border": "1px solid lightblue"
    }
  }), _vm._v(" "), _c('Row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMNInput),
      expression: "showMNInput"
    }],
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('i-col', {
    attrs: {
      "span": "10",
      "offset": "2"
    }
  }, [_c('label', [_vm._v("n")]), _vm._v("  "), _c('Input-number', {
    staticStyle: {
      "margin-top": "-6px"
    },
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.jilifuncValueN),
      callback: function($$v) {
        _vm.jilifuncValueN = $$v
      },
      expression: "jilifuncValueN"
    }
  })], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "12"
    }
  }, [_c('label', [_vm._v("m")]), _vm._v("  "), _c('Input-number', {
    staticStyle: {
      "margin-top": "-6px"
    },
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.jilifuncValueM),
      callback: function($$v) {
        _vm.jilifuncValueM = $$v
      },
      expression: "jilifuncValueM"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "border1",
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [_c('Row', {
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('i-col', {
    attrs: {
      "span": "8"
    }
  }, [_c('label', {
    attrs: {
      "for": "ma"
    }
  }, [_vm._v("中间升温速率")])]), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "16"
    }
  }, [_c('Input-number', {
    staticStyle: {
      "width": "100%",
      "margin-top": "-6px"
    },
    attrs: {
      "id": "ma",
      "size": "small"
    },
    model: {
      value: (_vm.middleHeatRate),
      callback: function($$v) {
        _vm.middleHeatRate = $$v
      },
      expression: "middleHeatRate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "border1"
  }, [_c('Row', [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "color": "white",
      "background-color": "#2d8cf0"
    }
  }, [_vm._v("实验数据导入")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "margin-top": "6px"
    }
  }, [_vm._v("备注： 数据excel表格值依次为： 时间(min)， 温度(°C)， 重量(mg)， 重量微分(%/°C) ")]), _vm._v(" "), _vm._l((_vm.heatRates), function(item, index) {
    return _c('Row', {
      key: index,
      staticStyle: {
        "margin-top": "12px"
      },
      attrs: {
        "gutter": 4
      }
    }, [_c('i-col', {
      attrs: {
        "span": "6"
      }
    }, [_vm._v("升温速率")]), _vm._v(" "), _c('i-col', {
      attrs: {
        "span": "6"
      }
    }, [_c('Input-number', {
      attrs: {
        "size": "small"
      },
      model: {
        value: (item.heatRate),
        callback: function($$v) {
          _vm.$set(item, "heatRate", $$v)
        },
        expression: "item.heatRate"
      }
    })], 1), _vm._v(" "), _c('i-col', {
      attrs: {
        "span": "4"
      }
    }, [_c('Badge', {
      attrs: {
        "dot": "",
        "count": item.init ? '0' : '1'
      }
    }, [_c('xlsx-importer', {
      attrs: {
        "heatRate": item.heatRate
      },
      on: {
        "on-select-file": _vm.handleSelectedFile
      }
    })], 1)], 1), _vm._v(" "), _c('i-col', {
      attrs: {
        "span": "4"
      }
    }, [_c('Button', {
      attrs: {
        "size": "small",
        "disabled": _vm.heatRates.length <= 1
      },
      on: {
        "click": function($event) {
          return _vm.removeHeatingRate(index)
        }
      }
    }, [_vm._v("删除")])], 1), _vm._v(" "), _c('i-col', {
      attrs: {
        "span": "4"
      }
    }, [(index === _vm.heatRates.length - 1) ? _c('Button', {
      attrs: {
        "size": "small"
      },
      on: {
        "click": _vm.addHeatingRate
      }
    }, [_vm._v("增加")]) : _vm._e()], 1)], 1)
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "20px 0"
    }
  }, [_c('Row', [_c('i-col', {
    attrs: {
      "span": "24"
    }
  }, [_c('Tooltip', {
    attrs: {
      "content": "计算最佳机理方程"
    }
  }, [_c('Button', {
    attrs: {
      "disabled": _vm.disableCalculateJili,
      "size": "large",
      "type": "primary",
      "loading": _vm.loadingJili
    },
    on: {
      "click": _vm.calculateJili
    }
  }, [_vm._v("机理方程")])], 1), _vm._v(" "), _c('Button', {
    attrs: {
      "disabled": _vm.disableCalculate,
      "size": "large",
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.calculate
    }
  }, [_vm._v("运        算")])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "item output border1"
  }, [_c('Tabs', {
    staticStyle: {
      "padding": "10px 15px"
    },
    attrs: {
      "animated": false
    }
  }, [_c('TabPane', {
    attrs: {
      "label": "活化能"
    }
  }, [_c('div', {
    staticClass: "chart-container"
  }, [_c('highcharts', {
    ref: "highchartsE0",
    attrs: {
      "options": _vm.e0Options
    }
  })], 1)]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "指前因子"
    }
  }, [_c('div', {
    staticClass: "chart-container"
  }, [_c('highcharts', {
    ref: "highchartsPreFactor",
    attrs: {
      "options": _vm.preFactorOptions
    }
  })], 1)]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "TG"
    }
  }, [_c('div', {
    staticClass: "chart-container"
  }, [_c('highcharts', {
    ref: "highchartsTg",
    attrs: {
      "options": _vm.tgOptions
    }
  })], 1)]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "DTG"
    }
  }, [_c('div', {
    staticClass: "chart-container"
  }, [_c('highcharts', {
    ref: "highchartsDtg",
    attrs: {
      "options": _vm.dtgOptions
    }
  })], 1)]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "转化率"
    }
  }, [_c('div', {
    staticClass: "chart-container"
  }, [_c('highcharts', {
    ref: "highchartsConvRate",
    attrs: {
      "options": _vm.convRateOptions
    }
  })], 1)]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "dα/dt-T"
    }
  }, [_c('div', {
    staticClass: "chart-container"
  }, [_c('highcharts', {
    ref: "highchartsDadtT",
    attrs: {
      "options": _vm.dadttOptions
    }
  })], 1)]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "斜率图"
    }
  }, [_c('div', {
    staticClass: "chart-container"
  }, [_c('highcharts', {
    ref: "highchartsDadt1T",
    attrs: {
      "options": _vm.dadt1tOptionsFM
    }
  })], 1)]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "斜率图"
    }
  }, [_c('div', {
    staticClass: "chart-container"
  }, [_c('highcharts', {
    ref: "highchartsDadt1T",
    attrs: {
      "options": _vm.dadt1tOptionsFwo
    }
  })], 1)]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "斜率图"
    }
  }, [_c('div', {
    staticClass: "chart-container"
  }, [_c('highcharts', {
    ref: "highchartsDadt1T",
    attrs: {
      "options": _vm.dadt1tOptionsKas
    }
  })], 1)]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "最佳机理方程"
    }
  }, [_c('div', {
    staticClass: "chart-container",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "10px"
    }
  }, [_c('b', [_vm._v("以Ea为准排序")]), _vm._v("  "), _c('Button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "size": "small",
      "type": "dashed"
    },
    on: {
      "click": function($event) {
        return _vm.exportData(1)
      }
    }
  }, [_vm._v("导出")])], 1), _vm._v(" "), _c('Scroll', [_c('Table', {
    ref: "table1",
    attrs: {
      "columns": _vm.columnsEa,
      "data": _vm.dataEa
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px"
    }
  }, [_c('b', [_vm._v("以LnA为准排序")]), _vm._v("  "), _c('Button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "size": "small",
      "type": "dashed"
    },
    on: {
      "click": function($event) {
        return _vm.exportData(2)
      }
    }
  }, [_vm._v("导出")])], 1), _vm._v(" "), _c('Scroll', [_c('Table', {
    ref: "table2",
    attrs: {
      "columns": _vm.columnsLnA,
      "data": _vm.dataLnA
    }
  })], 1)], 1)])], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_vm._v("生物质及木材热分解动力学参数多模式可视化求解软件V1.0 "), _c('a', {
    staticClass: "readme",
    attrs: {
      "href": "https://pan.baidu.com/s/1smMwpOh",
      "target": "_blank"
    }
  }, [_vm._v("软件说明")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46f94841","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard.vue
// module id = 112
// module chunks = 1